"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _util = require("@bento-core/util");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var footerTextStyle = {
  color: 'white',
  marginLeft: 16,
  marginRight: 16,
  fontWeight: 400,
  fontSize: '14px',
  fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
  lineHeight: '1.71',
  whiteSpace: 'nowrap',
  '@media (max-width: 600px)': {
    fontSize: 12
  }
};
var styles = function styles() {
  return {
    ext: {
      color: 'white',
      '@media (max-width: 600px)': {
        display: 'none'
      }
    },
    extraPadding: {
      marginTop: '10px',
      '@media (max-width: 600px)': {
        marginTop: '0px'
      }
    },
    footerText: _objectSpread({}, footerTextStyle),
    container: {
      top: '20%',
      left: '30%',
      boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
      position: 'absolute',
      width: '832px',
      backgroundColor: 'white',
      borderRadius: '10px',
      overflow: 'hidden'
    },
    modalFooter: {
      borderTop: '1px solid #E2E2E2',
      height: '70px',
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      paddingRight: '19px'
    },
    paper: {
      height: '443px',
      overflowY: 'auto',
      padding: '15px'
    },
    modalText: _objectSpread(_objectSpread({}, footerTextStyle), {}, {
      '&:hover': {
        textDecoration: 'underline'
      }
    }),
    modalFooterBtn: {
      backgroundColor: '#337AB7',
      color: '#FFF'
    },
    nciLinks: {
      display: 'flex',
      fontSize: '14px',
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
      '@media (max-width: 600px)': {
        flexDirection: 'column',
        marginLeft: '20px'
      }
    },
    listHeader: {
      paddingBottom: '4px',
      fontWeight: 600,
      fontSize: '14px',
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
    },
    footerRoot: function footerRoot(props) {
      return {
        background: props.background
      };
    },
    footerComponent: function footerComponent(props) {
      return {
        lineHeight: '1.42857143',
        maxWidth: '1800px',
        margin: '0 auto',
        '-webkit-font-smoothing': 'antialiased',
        color: 'white',
        padding: props.styles && props.styles.padding ? props.styles.padding : '24px 45px 45px 45px',
        '& ul': {
          listStyle: 'none',
          margin: '0',
          padding: '0'
        },
        '& li': {
          lineHeight: '2.17'
        },
        /* Style a button like a link for accessibility */
        '& button': {
          background: 'none!important',
          color: 'inherit',
          border: 'none',
          padding: '0!important',
          font: 'inherit',
          cursor: 'pointer'
        },
        '& a, & button': {
          color: 'white',
          textDecoration: 'none',
          '&:hover': {
            cursor: 'pointer',
            textDecoration: 'underline'
          }
        }
      };
    },
    footerRow: {
      display: 'flex',
      flexDirection: 'column',
      // width: '1200px',
      margin: '0 auto',
      '@media (min-width: 900px)': {
        flexDirection: 'row',
        justifyContent: 'space-between'
      }
    },
    footerRowSection: {
      marginTop: '16px',
      '@media (max-width: 900px)': {
        margin: '16px',
        marginTop: '45px'
      }
    },
    turningNIH: {
      fontSize: '14px',
      color: 'white',
      textDecoration: 'none'
    },
    footorVersiontext: {
      fontSize: '8px',
      color: 'white',
      textDecoration: 'none'
    },
    socialIcon: {
      width: '20px',
      height: '20px',
      marginLeft: 16
    },
    footerNciColumn: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      height: '30px',
      '@media (min-width: 600px)': {
        width: '200px'
      },
      '@media (min-width: 960px)': {
        width: '300px'
      },
      '& .nciBadge': {
        border: '0',
        height: '40px'
      }
    },
    footerBar: {
      color: 'white',
      backgroundColor: '#4F536B',
      width: '100%',
      textAlign: 'center',
      '-webkit-font-smoothing': 'antialiased',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      padding: '14px',
      marginTop: '48px'
    },
    contentJustifyCenter: {
      justifyContent: 'center'
    },
    contentJustifyLeft: {
      justifyContent: 'left'
    },
    horizontalLine: {
      width: '100%',
      margin: '32px auto 16px auto',
      backgroundColor: '#2E5573'
    },
    marginRight40: {
      marginRight: '40px'
    },
    footerLogoText: {
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      fontSize: '25px',
      letterSpacing: '-0.5px'
    },
    footerLogoSubText: {
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '5px',
      letterSpacing: '-0.5px'
    },
    nciLogo: {
      '@media (min-width: 960px)': {
        width: 'calc((100vw)/4)'
      },
      marginBottom: '10px'
    }
  };
};
var Footer = function Footer(_ref) {
  var classes = _ref.classes,
    data = _ref.data;
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    open = _react$default$useSta2[0],
    setOpen = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(''),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    content = _react$default$useSta4[0],
    setContent = _react$default$useSta4[1]; //* * set placement of system info display*/
  var systemInfoList = data.link_sections.filter(function (item) {
    return item.systemInfoInLinkSection;
  });
  var handleModalOpen = function handleModalOpen(itemContent) {
    itemContent.then(function (res) {
      setContent(res);
    });
    // console.log('itemContent', itemContent);
    // setContent(itemContent);
    setOpen(true);
  };
  var handleModalClose = function handleModalClose() {
    setOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerRoot
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerComponent
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRowSection, classes.footerNciColumn, classes.marginRight40)
  }, data.footerLogoHyperlink ? data.footerLogoText ? /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
    to: data.footerLogoHyperlink,
    className: classes.nciLogo
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerLogoText
  }, data.footerLogoText), /*#__PURE__*/_react.default.createElement("div", null, data.footerLogoSubText)) : /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
    to: data.footerLogoHyperlink,
    className: classes.nciLogo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: data.footerLogoImage,
    alt: data.footerLogoAltText,
    id: "footer_logo_image"
  })) : /*#__PURE__*/_react.default.createElement("img", {
    src: data.footerLogoImage,
    alt: data.footerLogoAltText,
    className: classes.nciLogo
  })), data.link_sections.slice(0, 4).map(function (linkSection) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.footerRowSection
    }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _util.cn)(classes.footerText, classes.listHeader)
    }, linkSection.title)), linkSection.items.slice(0, 5).map(function (footerRowSectionItem) {
      return /*#__PURE__*/_react.default.createElement("li", null, footerRowSectionItem.type === 'modal' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: classes.modalText,
        onClick: function onClick() {
          return handleModalOpen(footerRowSectionItem.content);
        }
      }, footerRowSectionItem.text)) : footerRowSectionItem.text && footerRowSectionItem.link ? /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
        to: footerRowSectionItem.link,
        title: footerRowSectionItem.title
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.footerText
      }, footerRowSectionItem.text)) : /*#__PURE__*/_react.default.createElement("div", {
        className: classes.footerText
      }, footerRowSectionItem.text), footerRowSectionItem.icon && /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
        to: footerRowSectionItem.link
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: footerRowSectionItem.icon,
        alt: data.footerLogoAltText,
        className: classes.socialIcon
      })));
    }))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.horizontalLine
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRow, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.nciLinks, classes.contentJustifyCenter)
  }, data.global_footer_links.slice(0, 4).map(function (nciLink, index) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_util.RouteLinks, {
      to: nciLink.link
    }, nciLink.text), index < data.global_footer_links.length - 1 && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.ext
    }, "\xA0|\xA0"));
  }))), data.footerStaticText && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRow, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.extraPadding, classes.nciLinks, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.turningNIH
  }, data.footerStaticText)))), data.version && systemInfoList.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRow, classes.contentJustifyLeft)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.extraPadding, classes.nciLinks, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.footorVersiontext
  }, "FE Version:\xA0", data.version)))), data.BEversion && systemInfoList.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRow, classes.contentJustifyLeft)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.nciLinks, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.footorVersiontext
  }, "BE Version:\xA0", data.BEversion)))), data.FileServiceVersion && systemInfoList.length === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.footerRow, classes.contentJustifyLeft)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.cn)(classes.nciLinks, classes.contentJustifyCenter)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.footorVersiontext
  }, "FS Version:\xA0", data.FileServiceVersion))))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: open,
    onClose: handleModalClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, null, content)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.modalFooterBtn,
    onClick: handleModalClose
  }, "Accept")))));
};
Footer.defaultProps = {
  background: '#23355B'
};
var _default = (0, _core.withStyles)(styles)(Footer);
exports.default = _default;